import { render, staticRenderFns } from "./StudyConversationMessageBody.vue?vue&type=template&id=6f40ef08&scoped=true"
import script from "./StudyConversationMessageBody.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageBody.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageBody.vue?vue&type=style&index=0&id=6f40ef08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40ef08",
  null
  
)

export default component.exports